import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { HttpService } from '@app-core/services/http/http.service';
import { environment } from '@environments/environment';
@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  public checked = true;
  private isOpen = false;

  public openStatus: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public updated: BehaviorSubject<boolean> = new BehaviorSubject(true);

  API_URL = `${environment.API_DOMAIN}/${environment.API_PATH_PREFIX}`;
  constructor(private httpService: HttpService) {}

  public toggle() {
    this.isOpen = !this.isOpen;
    this.openStatus.next(this.isOpen);
    this.updated.next(this.isOpen);
  }

  public getAllNotifications(type: string): Observable<any> {
    const path = `${this.API_URL}/notifications/${type}/`;
    const params = new HttpParams();
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    return this.httpService.get<any>(path, { params, headers });
  }

  /**
   *  Mark one as read
   * @param id id of notification
   * @param body turn to false message
   */
  public markAsRead(id, body): Observable<any> {
    const path = `${this.API_URL}/notifications/${id}/`;
    return this.httpService.put<any>(path, body);
  }

  /**
   *
   * Mark all as read
   */
  public markAllAsRead(body): Observable<any> {
    const path = `${this.API_URL}/notifications/`;
    return this.httpService.put<any>(path, body);
  }

  /**
   * Get all Notificagions - Pagination
   */
  public getPaginationNotifications(page): Observable<any> {
    const path = `${this.API_URL}/notifications/all/`;
    const params = new HttpParams().set('page', page);
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    return this.httpService.get<any>(path, { params, headers });
  }

  /**
   * Get Brach manager Cityes
   */
  public getBrachCities(): Observable<any> {
    const path = `${this.API_URL}/customer/contact/`;
    const params = new HttpParams().set('option', '2');
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    return this.httpService.get<any>(path, { params, headers });
  }
}
